"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : SECTION : STYLES --------------- ++++++++++ */


var _default = {
  section: {
    // ----- colors ----- //
    // generates classes for every color in the theme ".color-(uniqueColor)"
    extend: [_index.classStyleHelper.direction, _index.classStyleHelper.align, (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        background: theme.color[uniqueColor].medium.swatch,
        color: theme.color[uniqueColor].medium.contrast
      };
    })]
  }
};
exports.default = _default;